import * as React from 'react';
import { useAppDispatch } from '../../redux/store';
import {
  useTutorialEnabled,
  useTutorialProgress,
  useTutorialStep,
  useTutorialStepInfo,
} from '../../redux/tutorial/selectors';
import { TutorialThunk } from '../../redux/tutorial/thunks';
import { Button } from '../common/Button/Button';
import { Stack, StackDirection } from '../common/Stack';
import styles from './TutorialOverlay.module.css';

export const TutorialOverlay: React.FC = () => {
  const dispatch = useAppDispatch();
  const enabled = useTutorialEnabled();
  const step = useTutorialStep();
  const stepInfo = useTutorialStepInfo();
  const progress = useTutorialProgress();

  if (!enabled || step === 'completed') {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <Stack direction={StackDirection.Vertical} gap={8}>
          <div className={styles.eyebrow}>{stepInfo.eyebrow}</div>
          <div className={styles.progress}>
            Quest {progress.current}/{progress.total}
          </div>
          <div className={styles.title}>{stepInfo.title}</div>
          <div className={styles.description}>{stepInfo.description}</div>
          <div className={styles.objective}>{stepInfo.objective}</div>
          {stepInfo.status && <div className={styles.status}>{stepInfo.status}</div>}
          {stepInfo.attempts && <div className={styles.attempts}>{stepInfo.attempts}</div>}
          {stepInfo.reward && <div className={styles.reward}>{stepInfo.reward}</div>}
          {stepInfo.tip && <div className={styles.tip}>{stepInfo.tip}</div>}
        </Stack>

        <div className={styles.actions}>
          <Button className={styles.skipButton} onClick={() => dispatch(TutorialThunk.skipTutorial())}>
            Skip Tutorial
          </Button>
        </div>
      </div>
    </div>
  );
};
